<template>
  <div class="custom-gauge-chart" ref="chart"></div>
</template>

<script>
import * as echarts from "echarts";

export default {
  mounted() {
    this.createCustomGauge();
  },
  props: {
    acidityRawMilkOrGravityValue: {
      type: Number,
      required: true,
    },
    dialogCode: {
      type: String,
      required: true,
    },
  },
  methods: {
    createCustomGauge() {
      const chart = echarts.init(this.$refs.chart);

      const pathSymbols = {
        marker:
          "path://m199.565757,136.944121l21.902885,0l0,34.282792l-10.95145,8.570707l-10.951448,-8.570707l0.000012,-34.282792z",
      };

      let minRange = 0;
      let maxRange = 0;
      if (this.dialogCode === "specific-gravity") {
        minRange = 1;
        maxRange = 1.05;
      } else {
        minRange = 5;
        maxRange = 9;
      }

      const option = {
        yAxis: {
          show: false,
          boundaryGap: false,
          data: ["A"],
        },
        xAxis: [
          {
            type: "value",
            boundaryGap: true,
            min: minRange,
            max: maxRange,
            splitLine: {
              show: true,
            },
            axisLabel: {
              formatter: "{value}",
            },
            axisLine: {
              lineStyle: {
                color: "#000", // Color of the scale bar
                width: 5, // Width of the scale bar
              },
            },
            axisTick: {
              position: "inside",
              show: true, // Show axis ticks
              inside: true, // Place the ticks inside the axis
              length: 10, // Length of the smaller tick marks
              lineStyle: {
                color: "#000", // Color of the tick marks
                width: 1, // Width of the tick marks
              },
            },
          },
        ],
        series: [
          {
            type: "scatter",
            symbol: pathSymbols.marker,
            silent: false,
            itemStyle: {
              normal: {
                color: "rgba(0,0,0,0.3)",
                borderColor: "#000",
                borderWidth: 1,
              },
            },
            symbolSize: [15, 30],
            symbolOffset: ["0", "0"],
            z: 20,
            data: [Number(this.acidityRawMilkOrGravityValue)],
            label: {
              emphasis: {
                show: true,
                formatter: function (param) {
                  return param.data;
                },
                position: "top",
              },
            },
          },
          {
            type: "bar",
            silent: true,
            animation: false,
            barWidth: 20,
            itemStyle: {
              normal: {
                color: "rgb(79,173,96)",
              },
            },
            stack: "total",
            data: [20],
          },
          {
            type: "bar",
            silent: true,
            animation: false,
            barWidth: 20,
            itemStyle: {
              normal: {
                color: "rgb(157,185,101)",
              },
            },
            stack: "total",
            data: [20],
          },
          {
            type: "bar",
            silent: true,
            animation: false,
            barWidth: 20,
            itemStyle: {
              normal: {
                color: "rgb(255,253,91)",
              },
            },
            stack: "total",
            data: [20],
          },
          {
            type: "bar",
            silent: true,
            animation: false,
            barWidth: 20,
            itemStyle: {
              normal: {
                color: "rgb(241,147,80)",
              },
            },
            stack: "total",
            data: [20],
          },
          {
            type: "bar",
            silent: true,
            animation: false,
            barWidth: 20,
            itemStyle: {
              normal: {
                color: "rgb(200,82,76)",
              },
            },
            stack: "total",
            data: [20],
          },
        ],
      };

      chart.setOption(option);
    },
  },
};
</script>

<style scoped>
.custom-gauge-chart {
  width: 500px;
  height: 200px;
}
</style>
